import { render } from "./DevolucaoComprasListagem.vue?vue&type=template&id=3d5fc025&scoped=true&ts=true"
import script from "./DevolucaoComprasListagem.vue?vue&type=script&lang=ts"
export * from "./DevolucaoComprasListagem.vue?vue&type=script&lang=ts"

import "./DevolucaoComprasListagem.vue?vue&type=style&index=0&id=3d5fc025&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5fc025"]])

export default __exports__